

import './Footer.css';

function Footer({ navItems = [], onNavigate = () => {} }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <h3>CarbCareUSA</h3>
          <p>
            Carburetors, rebuild kits, and specialty fuel system solutions for marine,
            classic, Jeep, Toyota, hot rod, and performance applications.
          </p>
        </div>

        <div className="footer__links">
          <h4>Quick Links</h4>
          <div className="footer__nav-list">
            {navItems.map((item) => (
              <button
                key={item.path}
                type="button"
                className="footer__link"
                onClick={() => onNavigate(item.path)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="footer__contact">
          <h4>Contact</h4>
          <a className="footer__contact-link" href="tel:+16197611113">
            +1 (619) 761-1113
          </a>
          <a className="footer__contact-link" href="mailto:support@carbcareusa.com">
            support@carbcareusa.com
          </a>
          <span className="footer__contact-text">Mon–Fri · 9AM–5PM</span>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {year} CarbCareUSA. All rights reserved.</span>
        <span>Built for classic engines, marine systems, and performance carburetors.</span>
      </div>
    </footer>
  );
}

export default Footer;